import { render, staticRenderFns } from "./DetailB.vue?vue&type=template&id=2f58fcca&"
import script from "./DetailB.vue?vue&type=script&lang=js&"
export * from "./DetailB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports